export const radialApi = (http) => {
  return {
    fetchInstructionsForOrder: async (orderId) => {
      return http.get(
        `/api/shipment_orders/instructions/?sunday_order_id=${orderId}`
      );
    },
  };
};
